'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import Icon from '@/components/ui/AppIcon';

interface NavItem {
  label: string;
  path: string;
  icon: string;
  iconActive: string;
}

const MOBILE_NAV_ITEMS: NavItem[] = [
  { label: 'Home', path: '/homepage', icon: 'HomeIcon', iconActive: 'HomeIcon' },
  { label: 'Trade', path: '/trading-dashboard', icon: 'ChartBarIcon', iconActive: 'ChartBarIcon' },
  { label: 'Bots', path: '/trading-bots', icon: 'CpuChipIcon', iconActive: 'CpuChipIcon' },
  { label: 'Predict', path: '/predictions-market', icon: 'LightBulbIcon', iconActive: 'LightBulbIcon' },
  { label: 'Portfolio', path: '/portfolio-management', icon: 'BriefcaseIcon', iconActive: 'BriefcaseIcon' },
];

export default function MobileBottomNav() {
  const pathname = usePathname();

  return (
    <nav
      className="md:hidden fixed bottom-0 left-0 right-0 z-[300] flex items-stretch"
      style={{
        background: '#1a1a1a',
        borderTop: '1px solid #2a2a2a',
        paddingBottom: 'env(safe-area-inset-bottom)',
        boxShadow: '0 -4px 20px rgba(0,0,0,0.4)',
      }}
      aria-label="Mobile navigation"
    >
      {MOBILE_NAV_ITEMS.map((item) => {
        const isActive = pathname === item.path || pathname?.startsWith(item.path);
        return (
          <Link
            key={item.path}
            href={item.path}
            className="flex-1 flex flex-col items-center justify-center gap-1 py-2 transition-all duration-200 active:scale-95"
            style={{ minHeight: '56px' }}
            aria-current={isActive ? 'page' : undefined}
          >
            <Icon
              name={item.icon as any}
              size={22}
              variant={isActive ? 'solid' : 'outline'}
              className={isActive ? 'text-[#4c6ef4]' : 'text-[#64748B]'}
            />
            <span
              className="text-[10px] font-medium leading-none"
              style={{ color: isActive ? '#4c6ef4' : '#64748B' }}
            >
              {item.label}
            </span>
            {isActive && (
              <span
                className="absolute top-0 left-1/2 -translate-x-1/2 w-8 h-0.5 bg-[#4c6ef4]"
                style={{ borderRadius: '0 0 2px 2px' }}
              />
            )}
          </Link>
        );
      })}
    </nav>
  );
}
